import { Box, Link as MuiLink, Stack } from '@mui/material'
import { Link } from 'react-router-dom'

import logoDark from '~/assets/images/corp/logo-dark.svg'
import logoWhite from '~/assets/images/corp/logo-white.svg'
import { EMarketingClientPath } from '~/models/api'
import rem from '~/utils/ui'

type TProps = {
  colorTrigger: boolean
}

function Logo({ colorTrigger }: TProps) {
  return (
    <MuiLink
      component={Link}
      to={EMarketingClientPath.home}
      sx={{ textDecoration: 'none', mr: { xxxs: 1, xs: 2 } }}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{ gap: { xxxs: 0.5, xs: 2 } }}
      >
        <Box
          component="img"
          alt="logo"
          src={colorTrigger ? logoDark : logoWhite}
          sx={{
            width: {
              xxxs: rem(80),
              sm: rem(180),
            },
          }}
        />
      </Stack>
    </MuiLink>
  )
}

export default Logo
